module.exports = __webpack_public_path__ + "img/section1_img1.557af651.png";